import { SocietySearchPath, CourseSearchPath, CouncilResolutionSearchPath, JudicialResolutionSearchPath } from './../../constants/search-path';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchEndPoints } from 'src/app/constants/api-endpoints';
import { UserSearchPath, DoctorSearchPath, ClinicSearchPath } from 'src/app/constants/search-path';
import { Doctor } from '../../models/doctor/doctor.model';
import { CorrespondenceService } from 'src/app/sections/correspondence/services/correspondence.service';
import { Correspondence } from 'src/app/models/correspondence/correspondence.model';
import { HeaderService } from './services/header.service';
import { IHeaderState } from './services/interfaces/header.interface';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/sections/auth/services/auth.service';
import { User } from 'src/app/models/user.model';
import { CommonUIService } from 'src/app/sections/common/services/common.ui.service';
import { ApiService } from 'src/app/sections/common/services/api.service';
import * as moment from 'moment';
import { RecallService } from 'src/app/sections/dashboard/dashboard/recalls/services/recall.service';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from 'src/app/sections/common/services/socket.service';
import { Recall } from 'src/app/models/dashboard/recall.model';
import { Observable } from 'rxjs-compat';
import { HttpClient } from '@angular/common/http';
declare var require: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() headerTitle: string;
  @Output() getlocale: EventEmitter<any> = new EventEmitter();
  doctorGeneralDetails: Doctor;
  entryCorrespondenceList: Correspondence[];
  sentCorrespondenceList: Correspondence[];
  user: User;
  receiveCount = 0;
  sentCount = 0;
  isAddClassValue = false;

  private subscription: Subscription;
  private subscriptionAlert: Subscription;
  public url = GlobalSearchEndPoints.getGlobalSearchData;
  public search = '';
  public api = 'http';

  appVersion = "0.0.0"

  loggedUserId: any;
  recallList : Recall[] =[];
  alertBeforeInMin:number =1;
  intervalIds:any=[];

  alertMessage: string = '';

  constructor(private router: Router, private correspondenceService: CorrespondenceService, private headerService: HeaderService,
    public _commonUIService: CommonUIService, private authService: AuthService, private _apiServcie: ApiService,
    private recallService : RecallService,
    private toastService: ToastrService,
    private httpClient: HttpClient,
    private commonUiService : CommonUIService,
    private socketService: SocketService) {
    this.entryCorrespondenceList = [] as Correspondence[];
    this.sentCorrespondenceList = [] as Correspondence[];
    this.user = new User();
    const userDetails = this.authService.getTokenData();
    this.setUrlForGlobalSearch();
    if (userDetails) {
      this.user.username = userDetails.userName;
    }
    this.subscription = this._commonUIService.classState
      .subscribe((data: any) => {
        this.addClass(data);
      });

    this.subscription = this.headerService.headerCorrespondenceUpdateState
      .subscribe((state: IHeaderState) => {
        if (state.updateCorrespondence) {
          this.getCorrespondenceList();
        }
      });

      this.socketService.onMessage((message: string) => {
        this.alertMessage = message;
        this.getPendingRecalls();
      });
  }
  

  ngOnInit() {
    if (require('../../../../package.json') && require('../../../../package.json') != undefined) {
      this.appVersion = require('../../../../package.json').version;
    }
    this.getCorrespondenceList();
    this.getPendingRecalls();

    this.subscriptionAlert=this.headerService.triggerRecall().subscribe(res=>{
      if(res){
        this.getPendingRecalls();
      }
    });
  }

 

  async getPendingRecalls() {
    const config = await this.getJSON().toPromise();
    this.alertBeforeInMin = config.notification_timeout;
    const userDetails = this.authService.getTokenData();
  
    if (userDetails) {
      this.loggedUserId = userDetails.userId;
      this.recallService.getRecallListByUser(this.loggedUserId).subscribe((data: any) => {
        if (data._data) {
          const recallList = data._data.filter(recall => {
            const recallDateTime = this.getDateTime(recall.recallDate.toString(), recall.time);
            const alertTime = new Date(recallDateTime.getTime() - this.alertBeforeInMin * 60000);
            const now = new Date();
            const timeUntilAlert = alertTime.getTime() - now.getTime();
  
            return timeUntilAlert > 0;
          });

          const localList=JSON.parse(localStorage.getItem('recallList'));
          this.recallList = recallList;
          if(localList && localList.length>0){
              const isUpdated=  this.compareAndUpdateRecallList( this.recallList);
              if(isUpdated){
                this.setAlerts();
              }
          }else{
            localStorage.setItem('recallList', JSON.stringify(this.recallList));
            this.setAlerts();
            this.intervalIds=[];
          }
        }
      });
    }
  }

  setAlerts(){
    this.recallList.forEach(recall => {
      const recallDateTime = this.getDateTime(recall.recallDate.toString(), recall.time);
      const alertTime = new Date(recallDateTime.getTime() - this.alertBeforeInMin * 60000); // 30 mins before
      const now = new Date();
      const timeUntilAlert = alertTime.getTime() - now.getTime();
      
      if (timeUntilAlert > 0) {
        const intervalId = setInterval(() => {
          const formattedDate = this.formatDate(recallDateTime);
          const alert = `${formattedDate} - ${recall.recallType.recallTypeName} -<br>${recall.description}`;
          this.successToast(alert);
          clearInterval(intervalId);
          this.removeIntervalFromLocalStorage(intervalId);
          this.removeRecallFromLocalStorage(recall.id);

        }, timeUntilAlert);
        const formattedTime = alertTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        this.intervalIds.push({ intervalId: intervalId, id: recall.id,alertTime: formattedTime}); 
      }
    });
    localStorage.setItem('intervalIds', JSON.stringify(this.intervalIds));
  }

  removeIntervalFromLocalStorage(intervalId){
    let storedIntervals = JSON.parse(localStorage.getItem('intervalIds') || '[]');
    storedIntervals = storedIntervals.filter(item => item.intervalId !== intervalId);
    localStorage.setItem('intervalIds', JSON.stringify(storedIntervals));
    this.intervalIds = this.intervalIds.filter(item => item.intervalId !== intervalId);    
  }

  removeRecallFromLocalStorage(recallId){
    this.recallList = this.recallList.filter(recall => recall.id !== recallId);
    localStorage.setItem('recallList', JSON.stringify(this.recallList));
  }


  compareAndUpdateRecallList(recallList: any[]) {
    const oldRecallList = JSON.parse(localStorage.getItem('recallList') || '[]');
    const hasChanges = !this.areRecallsEqual(oldRecallList, recallList);
  
    if (hasChanges) {
     
      this.recallList = recallList;
      localStorage.setItem('recallList', JSON.stringify(this.recallList));
      const { updated, added ,removed} = this.identifyChanges(oldRecallList, recallList);
      this.recallList=[];
      if(updated.length>0){
       
        updated.forEach(record=>{
          let storedIntervals = JSON.parse(localStorage.getItem('intervalIds') || '[]');
          const intervalBeRemoved = storedIntervals.filter(item => item.id == record.id);
          intervalBeRemoved.forEach(interval=>{
            clearInterval(interval.intervalId);
            this.intervalIds =storedIntervals[0]?.intervalId ? storedIntervals.filter(item => item.intervalId !== interval.intervalId) :this.intervalIds ;
          });

          this.recallList.push(record);
          if(intervalBeRemoved.length>0){
            intervalBeRemoved.forEach(interval=>{
            this.removeIntervalFromLocalStorage(interval.intervalId)
            })
          }
        });
      }

      if(added.length>0){
        added.forEach(record=>{
          let storedIntervals = JSON.parse(localStorage.getItem('intervalIds') || '[]');
          this.intervalIds=storedIntervals;
          this.recallList.push(record);
        })
      }

      if(removed.length>0){
        removed.forEach(record=>{
          let storedIntervals = JSON.parse(localStorage.getItem('intervalIds') || '[]');
          const intervalBeRemoved = storedIntervals.filter(item => item.id == record.id);
          intervalBeRemoved.forEach(interval=>{
            clearInterval(interval.intervalId);
            this.intervalIds =storedIntervals[0]?.intervalId ? storedIntervals.filter(item => item.intervalId !== interval.intervalId) :this.intervalIds ;
          });

          if(intervalBeRemoved.length>0){
            intervalBeRemoved.forEach(interval=>{
            this.removeIntervalFromLocalStorage(interval.intervalId)
            })
          }
        });
      }
      return true;
    } else {
      return false;
    }
  }

  private identifyChanges(oldList: any[], newList: any[]): { updated: any[], added: any[], removed: any[] } {
    const updated: any[] = [];
    const added: any[] = [];
    const removed: any[] = [];

    // Identify newly added and updated records
    newList.forEach(newRecall => {
        const oldRecall = oldList.find(oldRecall => oldRecall.id === newRecall.id);

        if (!oldRecall) {
            added.push(newRecall); // New record
        } else if (this.hasRecallChanged(oldRecall, newRecall)) {
            updated.push(newRecall); // Existing record with changes
        }
    });

    // Identify removed records 
    oldList.forEach(oldRecall => {
        const stillExists = newList.some(newRecall => newRecall.id === oldRecall.id);
        if (!stillExists) {
            removed.push(oldRecall);
        }
    });

    return { updated, added, removed };
}

  // Helper function to check if any property of a recall has changed
  private hasRecallChanged(oldRecall: any, newRecall: any): boolean {
    return oldRecall.description !== newRecall.description ||
           oldRecall.recallDate !== newRecall.recallDate ||
           oldRecall.recallTypeId !== newRecall.recallTypeId ||
           oldRecall.time !== newRecall.time;
  }
  
  private areRecallsEqual(oldList: any[], newList: any[]): boolean {
    if (oldList.length !== newList.length) return false;

    return oldList.every(oldRecall => 
      newList.some(newRecall => 
        oldRecall.id === newRecall.id &&
        oldRecall.description === newRecall.description &&
        oldRecall.recallDate === newRecall.recallDate &&
        oldRecall.recallTypeId === newRecall.recallTypeId &&
        oldRecall.time === newRecall.time
      )
    );
  }
  
  successToast(message) {
      this.toastService.success(message, this.commonUiService.Translate('recallAlert'), {
        timeOut: 10000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right',
        enableHtml:true,
        toastClass: 'toast-blue'
      });
  }

  getDateTime(dateStr: string, timeStr: string): Date {
    return new Date(`${dateStr.split('T')[0]}T${timeStr}`);
  }
  formatDate(date: Date): string {
    const locale = localStorage.getItem('locale') || 'es';
    const daysOfWeek: { [key: string]: string[] } = {
        es: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    };

    const selectedDaysOfWeek = daysOfWeek[locale] || daysOfWeek['es']; 
    const dayOfWeek = selectedDaysOfWeek[date.getDay()];
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${dayOfWeek} ${day}/${month}/${year} ${this.commonUiService.Translate('at')} ${hours}:${minutes}`;
  }
  private getJSON(): Observable<any> {
    return this.httpClient.get('app/config.json');
  }

  setUrlForGlobalSearch() {
    this.url = this._apiServcie.BASE_URL + this.url;
  }

  addClass(classvlaue: boolean) {
    this.isAddClassValue = classvlaue;
  }

  get getTitle() {
    const data = this.router.url.split('/');
    data.splice(0, 1);
    const routerArray = [];
    for (let i = 0; i < data.length; i++) {
      const tempData = {
        routePath: (data[i - 1] ? data[i - 1]['routePath'] : '') + '/' + data[i],
        title: data[i]
      };
      routerArray.push(tempData);
    }
    return routerArray;
  }

  // Correspondence
  public getCorrespondenceList() {
    this.correspondenceService.getCorrespondenceList().subscribe(
      (data: any) => {
        if (data._data != null) {
          const correspondenceList = data._data;
          const today = moment(new Date()).format('YYYY-MM-DD');
          correspondenceList.forEach(element => {
            element.datestring = moment(element.date).format('YYYY-MM-DD');
          });
          this.entryCorrespondenceList = correspondenceList.filter(c => c.isEntry && c.datestring == today);
          this.receiveCount = this.entryCorrespondenceList.length;
          this.sentCorrespondenceList = correspondenceList.filter(c => !c.isEntry && c.datestring == today);
          this.sentCount = this.sentCorrespondenceList.length;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionAlert.unsubscribe();
  }


  // Intelligent Search
  handleResultSelected(result) {
    localStorage.removeItem('doctorFilter');
    localStorage.removeItem('sortColumn');
    localStorage.removeItem('sortOrder');
    if (result) {
      this.search = result.value;
      if (result.entity && result.value) {
        if (result.entity == UserSearchPath.module) {
          this.router.navigate([UserSearchPath.path]);
        } else if (result.entity == DoctorSearchPath.module) {
          this.router.navigate([DoctorSearchPath.path + result.referenceId]);
        } else if (result.entity == ClinicSearchPath.module) {
          this.router.navigate([ClinicSearchPath.path + result.referenceId]);
        } else if (result.entity == SocietySearchPath.module) {
          this.router.navigate([SocietySearchPath.path], { queryParams: { id: result.referenceId } });
        } else if (result.entity == CourseSearchPath.module) {
          this.router.navigate([CourseSearchPath.path], { queryParams: { id: result.referenceId } });
        } else if (result.entity == CouncilResolutionSearchPath.module) {
          this.router.navigate([CouncilResolutionSearchPath.path + result.referenceId]);
        } else if (result.entity == JudicialResolutionSearchPath.module) {
          this.router.navigate([JudicialResolutionSearchPath.path + result.referenceId]);
        }
      } else {
        console.log('result.entity or result.value null');
      }
    }
  }

  getLocaleId(prefix: string) {
    this.getlocale.emit(prefix);
  }

  ShowExpandView() {
    this._commonUIService.isActiveBothPanel = false;
    this._commonUIService.isShowExpandView = true;
  }

  ShowBothPanels() {
    this._commonUIService.isActiveBothPanel = true;
    this._commonUIService.isShowExpandView = false;
  }

}
